import api from "./api";
import types from "./types";
import { request } from "api/apiSaga";
import { call, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";
import { downloadFromRequest } from "helpers/download";

function* compareInventoriesFetch(action: AnyAction) {
    yield call(request, api.compareInventoriesFetch, action);
}

function* costAndVarianceFetch(action: AnyAction) {
    yield call(request, api.costAndVarianceFetch, action);
}

export default function* saga() {
    yield takeLatest(
        types.COMPARE_INVENTORIES_FETCH_REQUEST,
        compareInventoriesFetch,
    );
    yield takeLatest(
        types.COST_AND_VARIANCE_FETCH_REQUEST,
        costAndVarianceFetch,
    );
    yield takeLatest(types.REPORT_FETCH_REQUEST, function* (action: AnyAction) {
        yield call(request, api.fetch, action);
    });
    yield takeLatest(
        types.REPORT_DOWNLOAD_REQUEST,
        function* (action: AnyAction): any {
            const response = yield call(request, api.download, action);
            if (response.status === 200) {
                downloadFromRequest(response);
            }
            return response;
        },
    );
}
